import { useCallback, useEffect, useState } from "react";
import {
  obtenerAssetsTiendaSetup,
  actualizarAssetsTiendaSetup,
} from "../../../services/usuarios_tienda/tiendaSetup";

const TIPOS = [
  "LOGO_PRINCIPAL",
  "LOGO_SECUNDARIO",
  "LOGO_BLANCO",
  "LOGO_ICONO",
  "FAVICON",
  "BANNER",
  "OTRO",
];

function SetupTabAssets() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setMsg(null);
    const res = await obtenerAssetsTiendaSetup();
    if (res.ok) setRows(Array.isArray(res.data) ? res.data : []);
    else setMsg({ type: "err", text: res.message });
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const patchRow = (idx, field, value) => {
    setRows((prev) => {
      const next = [...prev];
      next[idx] = { ...next[idx], [field]: value };
      return next;
    });
  };

  const guardar = async () => {
    setSaving(true);
    setMsg(null);
    const res = await actualizarAssetsTiendaSetup({ assets: rows });
    if (res.ok) setMsg({ type: "ok", text: res.message || "Listo." });
    else setMsg({ type: "err", text: res.message });
    setSaving(false);
  };

  if (loading) {
    return <div className="tienda-setup-loading">Cargando…</div>;
  }

  if (!rows.length) {
    return <div className="tienda-setup-empty">No hay assets registrados para esta tienda.</div>;
  }

  return (
    <div className="tienda-setup-grid">
      {rows.map((row, idx) => (
        <div key={row.tienda_asset_id || idx} className={idx ? "tienda-setup-rowline" : ""}>
          <h3 className="tienda-setup-h3">Asset #{row.tienda_asset_id}</h3>
          <div className="tienda-setup-field">
            <label>Tipo</label>
            <select value={row.tipo || ""} onChange={(e) => patchRow(idx, "tipo", e.target.value)}>
              {TIPOS.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
          <div className="tienda-setup-field" style={{ marginTop: 10 }}>
            <label>Nombre</label>
            <input value={row.nombre || ""} onChange={(e) => patchRow(idx, "nombre", e.target.value)} />
          </div>
          <div className="tienda-setup-field" style={{ marginTop: 10 }}>
            <label>URL archivo</label>
            <input
              value={row.url_archivo || ""}
              onChange={(e) => patchRow(idx, "url_archivo", e.target.value)}
            />
          </div>
          <div className="tienda-setup-field" style={{ marginTop: 10 }}>
            <label>MIME</label>
            <input
              value={row.mime_type || ""}
              onChange={(e) => patchRow(idx, "mime_type", e.target.value)}
            />
          </div>
          <div className="tienda-setup-field" style={{ marginTop: 10 }}>
            <label>Orden</label>
            <input
              type="number"
              value={row.orden ?? 0}
              onChange={(e) => patchRow(idx, "orden", Number(e.target.value))}
            />
          </div>
          <div className="tienda-setup-field" style={{ marginTop: 10 }}>
            <label>Estado (1 activo)</label>
            <input
              type="number"
              min={0}
              max={1}
              value={row.estado ?? 1}
              onChange={(e) => patchRow(idx, "estado", Number(e.target.value))}
            />
          </div>
        </div>
      ))}
      <div className="tienda-setup-actions">
        <button type="button" className="tienda-setup-btn" disabled={saving} onClick={guardar}>
          {saving ? "Guardando…" : "Guardar cambios"}
        </button>
        {msg && (
          <p
            className={`tienda-setup-msg ${msg.type === "ok" ? "tienda-setup-msg-ok" : "tienda-setup-msg-err"}`}
          >
            {msg.text}
          </p>
        )}
      </div>
    </div>
  );
}

export default SetupTabAssets;
